

export default function Alert(props) {
    return (
        <div className={ 'bg-error-bg py-[8px] px-[16px] text-error-default rounded ' + props.className}>
           {props.text}
        </div>
    );
}
